export default [
    {
        path: 'notes',
        name: 'appUtilityNote',
        redirect: { name: 'appUtilityNoteList' },
        meta: {
            title: 'utility.note.notes',
            icon: 'far fa-check-square',
            hideChildren: true,
            permissions: ['list-note', 'manage-note', 'manage-note-config']
        },
        component: {
            template: '<router-view></router-view>'
        },
        children: [
            {
                path: '',
                name: 'appUtilityNoteList',
                meta: {
                    trans: 'global.list',
                    title: 'utility.note.notes',
                    permissions: ['list-note'],
                },
                component: () => import('@views/app/utility/note/index.vue'),
            },
            {
                path: 'add',
                name: 'appUtilityNoteAdd',
                meta: {
                    trans: 'global.add',
                    title: 'utility.note.note',
                    permissions: ['manage-note'],
                },
                component: () => import('@views/app/utility/note/add.vue'),
            },
            {
                path: ':uuid/edit',
                name: 'appUtilityNoteEdit',
                meta: {
                    trans: 'global.edit',
                    title: 'utility.note.note',
                    permissions: ['manage-note'],
                },
                component: () => import('@views/app/utility/note/edit.vue'),
            },
            {
                path: ':uuid/duplicate',
                name: 'appUtilityNoteDuplicate',
                meta: {
                    trans: 'global.add',
                    title: 'utility.note.note',
                    permissions: ['manage-note'],
                },
                component: () => import('@views/app/utility/note/edit.vue'),
            },
            {
                path: ':uuid',
                name: 'appUtilityNoteView',
                meta: {
                    trans: 'global.view',
                    title: 'utility.note.note',
                    permissions: ['list-note'],
                },
                component: () => import('@views/app/utility/note/view.vue'),
            }
        ]
    },
]
